<template>
  <div>
    <div class="bg pic-full"></div>
    <!-- <warn class="warn" :home-lang="home"></warn> -->
    <div class="home">
      <header>
        <head-nav-bar class="head-nav-bar" :home-lang="home"></head-nav-bar>
        <head-nav-bar-mini class="head-nav-bar-mini" :home-lang="home"></head-nav-bar-mini>
      </header>
      <main class="donation-main">
        <donation-introduction class="donation-introduction" :home-lang="home"></donation-introduction>
        <donation-content class="donation-content" :home-lang="home"></donation-content>
      </main>
      <footer>
        <foot-content class="foot-content" :home-lang="home"></foot-content>
      </footer>
    </div>
  </div>
</template>

<script>
import home from "@/lang/en/home"
import Warn from "@/components/contents/warn";
import HeadNavBar from "@/components/Layouts/HeadNavBar";
import FootContent from "@/components/Layouts/FootContent";
import HeadNavBarMini from "@/components/Layouts/HeadNavBarMini";
import DonationIntroduction from "@/components/donation/donationIntroduction";
import DonationContent from "@/components/donation/donationContent";


export default {
  name: "Donation",
  components: {
    Warn,
    DonationContent,
    DonationIntroduction,
    HeadNavBar,
    HeadNavBarMini,
    FootContent,
  },
  data() {
    return {
      home: home,
    }
  }
}
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .donation-main {
    width: 10rem;
    margin: 0 auto 1.37rem;
    position: relative;
  }
}
@media screen and (max-width: 767px) {

}
</style>
